import { z } from 'zod';

import { chatEventIdSchema, chatMessageIdSchema, chatThreadIdSchema } from './chat-ids';
import { contextRefreshEventSchema } from './context-refresh-event';
import { structuredResponseEventSchema } from './structured-event';

export const errorPayloadSchema = z.object({
    code: z.string(),
    message: z.string(),
});

export type ErrorPayload = z.infer<typeof errorPayloadSchema>;

export const messageStartEventSchema = z.object({
    eventId: chatEventIdSchema,
    eventType: z.literal('message-start'),
    messageId: chatMessageIdSchema,
    threadId: chatThreadIdSchema,
    timestamp: z.string(),
});

export type MessageStartEvent = z.infer<typeof messageStartEventSchema>;

export const completeEventSchema = z.object({
    eventId: chatEventIdSchema,
    eventType: z.literal('complete'),
    messageId: chatMessageIdSchema,
    threadId: chatThreadIdSchema,
    timestamp: z.string(),
});

export type CompleteEvent = z.infer<typeof completeEventSchema>;

export const errorEventSchema = z.object({
    eventId: chatEventIdSchema,
    eventType: z.literal('error'),
    messageId: chatMessageIdSchema,
    payload: errorPayloadSchema,
    threadId: chatThreadIdSchema,
    timestamp: z.string(),
});

export type ErrorEvent = z.infer<typeof errorEventSchema>;

export const sseEnvelopeSchema = z.discriminatedUnion('eventType', [
    messageStartEventSchema,
    structuredResponseEventSchema,
    completeEventSchema,
    errorEventSchema,
    contextRefreshEventSchema,
]);

export type SseEnvelope = z.infer<typeof sseEnvelopeSchema>;

export type ChunkEvent = {
    readonly eventId: string;
    readonly eventType: 'chunk';
    readonly text: string;
};

export type ChatStreamEvent = ChunkEvent | SseEnvelope;
